import { render } from "./single-card.vue?vue&type=template&id=83c157d4"
import script from "./single-card.vue?vue&type=script&lang=js"
export * from "./single-card.vue?vue&type=script&lang=js"

import "./single-card.vue?vue&type=style&index=0&id=83c157d4&lang=scss"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__